<template>
  <div>
    <Popup v-if="openPop" v-on:close="openPop=false">
      <div slot="table" class="p-3">
        <div v-if="recognizeData" style="overflow:auto; height:55vh"  id="style-1">
          <table class="table table-borderless">
            <thead>
              <tr>
                <th>{{$t('learning_contents')}}</th>
                <th>失敗次數</th>
                <th>{{$t('play')}}</th>
                <th>{{$t('download')}}</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in recognizeData.data" :key="index" style="border-top:1px #cccccc solid;text-align: left; " >
              <tr>
                <td style="width:40%">
                  {{item.sentence}}
                </td>
                <td>
                  {{item.recognizeTimes}}
                </td>
                <td>
                  <a style="color:blue"  class="pointer" @click="playAudio(item.voiceUrl)">
                    {{$t('play')}}
                  </a>
                </td>
                <td>
                  <a download  style="color:blue" target="_blank" :href="item.voiceUrl">
                    {{$t('download')}}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <audio id="audio">
            <source :src="voiceUrl" type="audio/ogg">
          </audio>
        </div>
      </div>
    </Popup>
    <h2 class="px-5" style="text-align: left;">{{this.userInfo.realName}}</h2>
    <label-tag/>
    <div class="px-5 table-responsive" style="overflow:auto; min-height:50vh;font-size:1.25rem">
      <table class="table table-borderless table-hover">
        <thead>
          <tr>
            <th class="order-btn pointer">
              任務主題
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th>任務點</th>
            <th class="order-btn pointer">
              任務關卡
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th class="order-btn pointer">
              挑戰時間
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th class="order-btn pointer">
              任務評價
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th class="order-btn pointer">
              完成時間
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th>
              {{$t('oral_practice')}}
            </th>
          </tr>
        </thead>
        <tbody style="border-top:1px #cccccc solid;text-align: left;">
          <tr v-for="(item , index) in record.data" :key="index">
            <td>
              {{item.missionName}}
            </td>
            <td>
              {{item.missionPointName}}
            </td>
            <td>
              {{item.sceneName?item.sceneName:'-'}}
            </td>
            <td>
              {{item.createTime}}
            </td>
            <td>
              {{item.grade?item.grade:'-'}}
            </td>
            <td>
              {{item.spendTime}}
            </td>
            <td >
              <a v-if="!item.hasRecognize" class="disabled" href="javascript:void(0);">
                detal
              </a>
              <a v-else @click="goInfo(item.recordId)" href="javascript:void(0);">
                detal
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Pagination class="mt-5" :current="record.pageIndex" :total="record.pageCount" v-on:page="updatePage" />
  </div>
</template>

<script>
import api from '../../../../store/api'
import Pagination from '../../../../components/Pagination'
import labelTag from '../../tw/record/Label'
import Popup from './Popup'
export default {

  name: 'TWRecordMissionInfo',

  data () {
    return {
      openPop: false,
      record: {},
      pageIndex: 1,
      orderBy: 'userName',
      recognizeData: {},
      voiceUrl: '',
      userInfo: ''
    }
  },
  components: {
    labelTag,
    Pagination,
    Popup
  },
  computed: {
    topicId () {
      return this.$route.params.topic
    },
    userId () {
      return this.$route.params.student
    }
  },
  mounted () {
    this.getRecordData()
    this.getStudentInfo()
  },
  methods: {
    updatePage (page) {
      this.pageIndex = page
      this.getRecordData()
    },
    goInfo (id) {
      this.openPop = true
      this.getRecognizeData(id)
    },
    async getRecordData () {
      let params = {
        sceneId: this.topicId,
        userId: this.userId,
        pageIndex: this.pageIndex
      }
      const { data } = await api.get(`TravelTaiwan/Record/MissionScene/App/Summary`, { params })
      this.record = data
    },
    async playAudio (url) {
      this.voiceUrl = url
      let dom = document.getElementById('audio')
      await dom.load()
      await dom.play()
    },
    async getRecognizeData (id) {
      let params = {
        recordId: id,
        userId: this.userId
      }
      const { data } = await api.get(`TravelTaiwan/Record/MissionScene/App/Recognize`, { params })
      this.recognizeData = data
    },
    async getStudentInfo () {
      const { data } = await api.get(`/TravelTaiwan/Record/Student/App/Summary`, {params: {userId: this.userId}})
      this.userInfo = data.data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/style/color.scss";
  .list-box {
    width: 60%;
    margin: auto;
  }
  .menu-box {
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    border-radius: 10px;
    border: 1.5px solid #6666;
    margin: 10px auto;
    padding: 10px 20px;
    p {
      margin: 0;
    }
      &:hover {
      box-shadow:0px 0px 8px #a1a1a1;
    }
  }
  .order-btn {
    color: rgb(1, 1, 187);
  }
  .disabled {
    color: #a1a1a1;
    text-decoration: none;
    cursor: auto;
  }
</style>


// WEBPACK FOOTER //
// RecordMissionInfo.vue?3895a21a